import React, { useMemo } from "react";

/**
 * Wraps the app in Shopify App Bridge context.
 * In a Shopify admin embed, the host and session token are passed via URL params
 * and injected into cookies by Shopify's middleware.
 *
 * This component validates that we're running in an admin context by checking
 * for the required `host` parameter. If missing, renders a fallback.
 */
export default function AppBridgeProvider({ children }) {
  const isAdmin = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.has("host");
  }, []);

  if (!isAdmin) {
    return (
      <div style={{ padding: 20, fontFamily: "monospace" }}>
        <h1>BO Loyalty Admin</h1>
        <p style={{ color: "#b91c1c" }}>
          Bu uygulama yalnızca Shopify Admin içinden açılabilir.
          Şuradan açın: <a href="https://admin.shopify.com/store/buyuklere-oyuncaklar/apps/bo-loyalty">Shopify Admin → Apps → BO Loyalty</a>
        </p>
      </div>
    );
  }

  return children;
}
